module.exports = __webpack_public_path__ + "img/logo-header.57f9a7c.png";